import { render, staticRenderFns } from "./DeleteDisableScriptModal.vue?vue&type=template&id=5b8a351a&"
import script from "./DeleteDisableScriptModal.vue?vue&type=script&lang=js&"
export * from "./DeleteDisableScriptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports